import UploadItem from './UploadItem';
import UploadItemSkeleton from './UploadItemSkeleton';

export default {
  Item: UploadItem,
  Skeleton: UploadItemSkeleton,
};
